import React from "react";
import styles from "./UpgradePlanBanner.module.scss";
import { useAtom } from "jotai";
import { showUpgradeBannerAtom } from "showMessageMenuAtom";
import { Link } from "react-router-dom";
import Moment from "react-moment";


const UpgradePlanBanner = () => {
  const [showBanner, ] = useAtom(showUpgradeBannerAtom) as any;

  if (!showBanner.isOpen) return null;

  return (
    <div className={`${styles.UpgradePlanBanner}`} id='UpgradePlanBanner'>
      {
        showBanner.isFreeCommunity
          ?
          <div className={styles.UpgradePlanBanner__content}>
            <div className={styles.UpgradePlanBanner__message}>
              <span className={styles.UpgradePlanBanner__special}>
                {
                  showBanner.isOnTrail ?
                  `Your trial ends in ${showBanner.daysLeft}. Save 30% when you upgrade by ${showBanner.upgradeBeforeDate}.`
                    :
                    `Start your 14-day free trial to go live. Save 30% when you upgrade by ${showBanner.upgradeBeforeDate}.`
                }
              </span>
            </div>
            <Link
              to={`/settings/billing/plans`}
              className={styles.UpgradePlanBanner__upgradeButton}
              // onClick={() => {
              //   if (showBanner.isWithin7Days) {
              //     localStorage.setItem('apply_30_upgrade_coupon', 'true');
              //     return
              //   }
              // }}
            >
              <button>
                {
                  showBanner.isWithin7Days ?
                    'Save 30%'
                    :
                    'Start Trial'
                }
              </button>
            </Link>
          </div>
          :
          <>
            {
              showBanner.emailNotVerified
                ?
                <div className={styles.UpgradePlanBanner__email}>
                  <div className={styles.UpgradePlanBanner__message}>
                    <span className={styles.UpgradePlanBanner__special}>
                      Please verify your email address.
                    </span>
                  </div>
                  <button
                    className={styles.UpgradePlanBanner__resendButton_email}
                    onClick={() => showBanner.fn()}
                  >
                    Verify Email
                  </button>
                </div>
                :
                <>
                  {
                    showBanner.cardChargedFailed
                      ?
                      <div className={styles.UpgradePlanBanner__content}>
                        <div className={styles.UpgradePlanBanner__message}>
                          <span className={styles.UpgradePlanBanner__special}>
                            Charging your card failed.
                          </span>
                        </div>
                        <Link
                          to={`/settings/billing`}
                          className={styles.UpgradePlanBanner__upgradeButton}
                        >
                          <button>
                            Update Card
                          </button>
                        </Link>
                      </div>
                      :

                      <div className={styles.UpgradePlanBanner__content}>
                        <div className={styles.UpgradePlanBanner__message}>
                          <span className={styles.UpgradePlanBanner__special}>
                            {
                              showBanner.isWithin7Days ?
                                `Save 30% on Starter & Pro plans when you upgrade to yearly by ${showBanner.upgradeBeforeDate}.`
                                :
                                <>
                                  {
                                    showBanner.daysLeft === '1 day'
                                      ?
                                      <>1 day</>
                                      :
                                      <span style={{ textTransform: 'capitalize' }}><Moment fromNow ago>{showBanner.trialDate}</Moment></span>
                                  }
                                  &nbsp;left on your free trial.
                                </>
                            }
                          </span>

                        </div>
                        {
                          showBanner.isWithin7Days &&
                          <Link
                            to={`/settings/billing/plans`}
                            className={styles.UpgradePlanBanner__upgradeButton}
                            // onClick={() => {
                            //   if (showBanner.isWithin7Days) {
                            //     localStorage.setItem('apply_30_upgrade_coupon', 'true');
                            //     return
                            //   }
                            // }}
                          >
                            <button>
                              Save 30%
                            </button>
                          </Link>
                        }
                      </div>
                  }
                </>
            }
          </>
      }
      {/* {
        (!showBanner.emailNotVerified || showBanner.cardChargedFailed) &&
        <button onClick={handleDismiss} className={styles.UpgradePlanBanner__dismissButton}>
          <XIcon />
        </button>
      } */}
    </div>
  );
};

export default UpgradePlanBanner;
